const studioTourSteps = [
  {
    target: '[data-v-step="studio-tour-create-module"]',
    content: 'Create a new module with custom fields, tables and lists.',
    params: {
      placement: 'top',
    },
  },
  {
    target: '[data-v-step="studio-tour-help"]',
    content: 'I want to take a tour of Inistate Studio again',
    params: {
      placement: 'right',
    },
  },
  {
    target: '[data-v-step="studio-tour-invite-user"]',
    content: 'Invite your teammates to the workspace and start collaborating together.',
    params: {
      placement: 'right',
    },
  },
  {
    target: '[data-v-step="studio-tour-manage-user"]',
    content: 'You can manage the users in your workspace here.',
    params: {
      placement: 'right',
    },
  },
  {
    target: '[data-v-step="studio-tour-workspace-settings"]',
    content: 'Edit your workspace settings here.',
    params: {
      placement: "bottom-end",
    },
  },
];

const moduleRunSteps = [
  {
    target: '[data-v-step="studio-tour-run"]',
    content: 'Click to run app',
    params: {
      enableScrolling: false,
      strategy: 'fixed',
    },
  },
];

const moduleStartSteps = [
  {
    target: '[data-v-step="studio-tour-start"]',
    content: 'Click to start to configure this module',
    params: {
      enableScrolling: false
    },
  }
];

export default {
  studioTourSteps: studioTourSteps,
  moduleRunSteps: moduleRunSteps,
  moduleStartSteps: moduleStartSteps,
}